var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E0F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 21C7 21 10.4844 13 20.75 13C31.0156 13 34.5 21 34.5 21C34.5 21 31.0156 29 20.75 29C10.4844 29 7 21 7 21Z",
    stroke: "#00A3FA",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21C25 23.2109 23.2109 25 21 25C18.7891 25 17 23.2109 17 21C17 18.7891 18.7891 17 21 17C23.2109 17 25 18.7891 25 21Z",
    stroke: "#00A3FA",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewedIcon);
export default __webpack_public_path__ + "static/media/viewed-icon.fe9536483942aee98bd4a4f59a3305b8.svg";
export { ForwardRef as ReactComponent };